import { Permission, type User } from '../types/auth';

/** When a user has multiple JWT groups, first matching permission wins. */
const LANDING_PRIORITY: Permission[] = [
  Permission.TRAY_ASSEMBLER,
  Permission.TRAY_SCANNER,
  Permission.CART_BUILDER,
  Permission.OR_ASSIGN,
  Permission.SPD_RELEASE,
  Permission.ASSET_FINDER,
  Permission.OR_NURSE,
  Permission.IMPLEMENTATION_ENGINEER,
];

function pathForPermission(permission: Permission): string {
  switch (permission) {
    case Permission.CART_BUILDER:
      return '/case-cart-assembly';
    case Permission.TRAY_ASSEMBLER:
      return '/assemble-tray';
    case Permission.TRAY_SCANNER:
      return '/assemble-tray';
    case Permission.SPD_RELEASE:
      return '/release-from-case';
    case Permission.OR_ASSIGN:
      return '/assign-to-case';
    case Permission.ASSET_FINDER:
      return '/find-asset';
    case Permission.IMPLEMENTATION_ENGINEER:
      return '/entity-management';
    case Permission.OR_NURSE:
      return '/case-schedule';
    default:
      return '/find-asset';
  }
}

/**
 * Default post-login route from role matrix + multi-permission fallback.
 * Does not use JWT `main_group` (see PVS-1677).
 */
export function getLandingPath(user: User | null): string {
  if (!user?.isActive) {
    return '/find-asset';
  }
  if (user.isAdmin) {
    return '/assemble-tray';
  }

  const perms = user.permissions ?? [];
  if (perms.length === 0) {
    return '/find-asset';
  }
  if (perms.length === 1) {
    return pathForPermission(perms[0]);
  }

  for (const p of LANDING_PRIORITY) {
    if (perms.includes(p)) {
      return pathForPermission(p);
    }
  }

  return '/find-asset';
}
